import { render, staticRenderFns } from "./OpenTickets.vue?vue&type=template&id=1b632ddc&scoped=true&"
import script from "./OpenTickets.vue?vue&type=script&lang=js&"
export * from "./OpenTickets.vue?vue&type=script&lang=js&"
import style1 from "./OpenTickets.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b632ddc",
  null
  
)

export default component.exports